import { render, staticRenderFns } from "./PrkFooterNavbar.vue?vue&type=template&id=35f82c1b&scoped=true&"
import script from "./PrkFooterNavbar.vue?vue&type=script&lang=js&"
export * from "./PrkFooterNavbar.vue?vue&type=script&lang=js&"
import style0 from "./PrkFooterNavbar.vue?vue&type=style&index=0&id=35f82c1b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f82c1b",
  null
  
)

export default component.exports